module.exports = __webpack_public_path__ + "img/kuber.12fb4f3.png";